<template>
  <div class="page-load">
    <div class="loader">
      Loading...
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="postcss" scoped>
  .page-load {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.8);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loader {
    margin: auto;
    font-size: 13px;
    width: 1.1em;
    height: 1.1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: load5 1.1s infinite ease;
    transform: translateZ(0);
  }
  @keyframes load5 {
    0%,
    100% {
      box-shadow: 0em -2.6em 0em 0em #d7000f, 1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2), 2.5em 0em 0 0em rgba(217, 28, 41, 0.2), 1.75em 1.75em 0 0em rgba(217, 28, 41, 0.2), 0em 2.5em 0 0em rgba(217, 28, 41, 0.2), -1.8em 1.8em 0 0em rgba(217, 28, 41, 0.2), -2.6em 0em 0 0em rgba(217, 28, 41, 0.5), -1.8em -1.8em 0 0em rgba(217, 28, 41, 0.7);
    }
    12.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(217, 28, 41, 0.7), 1.8em -1.8em 0 0em #d7000f, 2.5em 0em 0 0em rgba(217, 28, 41, 0.2), 1.75em 1.75em 0 0em rgba(217, 28, 41, 0.2), 0em 2.5em 0 0em rgba(217, 28, 41, 0.2), -1.8em 1.8em 0 0em rgba(217, 28, 41, 0.2), -2.6em 0em 0 0em rgba(217, 28, 41, 0.2), -1.8em -1.8em 0 0em rgba(217, 28, 41, 0.5);
    }
    25% {
      box-shadow: 0em -2.6em 0em 0em rgba(217, 28, 41, 0.5), 1.8em -1.8em 0 0em rgba(217, 28, 41, 0.7), 2.5em 0em 0 0em #d7000f, 1.75em 1.75em 0 0em rgba(217, 28, 41, 0.2), 0em 2.5em 0 0em rgba(217, 28, 41, 0.2), -1.8em 1.8em 0 0em rgba(217, 28, 41, 0.2), -2.6em 0em 0 0em rgba(217, 28, 41, 0.2), -1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2);
    }
    37.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(217, 28, 41, 0.2), 1.8em -1.8em 0 0em rgba(217, 28, 41, 0.5), 2.5em 0em 0 0em rgba(217, 28, 41, 0.7), 1.75em 1.75em 0 0em #d7000f, 0em 2.5em 0 0em rgba(217, 28, 41, 0.2), -1.8em 1.8em 0 0em rgba(217, 28, 41, 0.2), -2.6em 0em 0 0em rgba(217, 28, 41, 0.2), -1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2);
    }
    50% {
      box-shadow: 0em -2.6em 0em 0em rgba(217, 28, 41, 0.2), 1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2), 2.5em 0em 0 0em rgba(217, 28, 41, 0.5), 1.75em 1.75em 0 0em rgba(217, 28, 41, 0.7), 0em 2.5em 0 0em #d7000f, -1.8em 1.8em 0 0em rgba(217, 28, 41, 0.2), -2.6em 0em 0 0em rgba(217, 28, 41, 0.2), -1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2);
    }
    62.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(217, 28, 41, 0.2), 1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2), 2.5em 0em 0 0em rgba(217, 28, 41, 0.2), 1.75em 1.75em 0 0em rgba(217, 28, 41, 0.5), 0em 2.5em 0 0em rgba(217, 28, 41, 0.7), -1.8em 1.8em 0 0em #d7000f, -2.6em 0em 0 0em rgba(217, 28, 41, 0.2), -1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2);
    }
    75% {
      box-shadow: 0em -2.6em 0em 0em rgba(217, 28, 41, 0.2), 1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2), 2.5em 0em 0 0em rgba(217, 28, 41, 0.2), 1.75em 1.75em 0 0em rgba(217, 28, 41, 0.2), 0em 2.5em 0 0em rgba(217, 28, 41, 0.5), -1.8em 1.8em 0 0em rgba(217, 28, 41, 0.7), -2.6em 0em 0 0em #d7000f, -1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2);
    }
    87.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(217, 28, 41, 0.2), 1.8em -1.8em 0 0em rgba(217, 28, 41, 0.2), 2.5em 0em 0 0em rgba(217, 28, 41, 0.2), 1.75em 1.75em 0 0em rgba(217, 28, 41, 0.2), 0em 2.5em 0 0em rgba(217, 28, 41, 0.2), -1.8em 1.8em 0 0em rgba(217, 28, 41, 0.5), -2.6em 0em 0 0em rgba(217, 28, 41, 0.7), -1.8em -1.8em 0 0em #d7000f;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Loading.vue